import React from "react";
import {
  FieldError,
  FieldErrorsImpl,
  FieldValues,
  Merge,
  UseFormRegister,
} from "react-hook-form";

interface InputProps {
  label?: string;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  placeholder?: string;
  value?: string;
  name?: string;
  formFieldClassName?: string;
  register?: UseFormRegister<FieldValues>;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  error?: string | FieldError | Merge<FieldError, FieldErrorsImpl<any>>;
  className?: string;
  required?: boolean;
  readOnly?: boolean;
  required_asterik?: boolean;
  disabled?: boolean;
  isNotEditable?: boolean;
}

const FormTextarea: React.FC<InputProps> = (params) => {
  return (
    <div className={`w-full flex flex-col gap-1 ${params.formFieldClassName}`}>
      {params.label && (
        <label className="block text-[0.6rem] font-medium mb-1">
          {params.required || params.required_asterik ? (
            <span className="text-error">*</span>
          ) : (
            ""
          )}{" "}
          {params.label}
        </label>
      )}
      {!params.isNotEditable ? (
        <textarea
          name={params.name}
          placeholder={params.placeholder}
          value={params.value}
          onChange={params.onChange}
          {...params.register?.(params.name!)}
          required={params.required}
          readOnly={params.readOnly}
          disabled={params.disabled}
          className={`disabled:opacity-50 textarea font-bold placeholder:font-light text-primary textarea-sm textarea-bordered textarea-primary ${
            params.error ? "border-error" : "border-primary"
          } ${params.className} ${
            !params.size
              ? "!textarea-xs textarea-sm textarea-md textarea-lg textarea-xl"
              : `textarea-${params.size}`
          }`}
        ></textarea>
      ) : (
        <span className="text-xs italic text-accent">
          {params.value || "-"}
        </span>
      )}

      {params.error && (
        <p className="text-error text-xs mt-1">{params.error?.toString()}</p>
      )}
    </div>
  );
};

export default FormTextarea;
